import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-73a2f312"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "work" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "work-text" }, [
    /*#__PURE__*/_createElementVNode("h1", null, [
      /*#__PURE__*/_createTextVNode(" Transform Your Business with "),
      /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgba(0, 150, 136, 1)"} }, "POSA")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "ml-2" }, " Experience our flagship product, Posa - a comprehensive business management platform that helps you record sales, manage inventory, setup online stores, and eliminate fraud across all platforms. ")
  ])
], -1))
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "form-item-last" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"600"} }, "Project Type", -1))
const _hoisted_5 = { class: "radio" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "New",
  class: "mr-5"
}, "New Project", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Existing" }, "Existing Project", -1))
const _hoisted_8 = { class: "form-item-last" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"600"} }, "What services are you interested in?", -1))
const _hoisted_10 = { class: "check" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "4" }, "Posa SAAS Platform", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "5" }, "Sales Recording System", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "6" }, "Inventory Management", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "7" }, "Online Store Setup", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "8" }, "Fraud Prevention System", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "9" }, "Other", -1))
const _hoisted_17 = { class: "form-item-last" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"600"} }, "Do you have any functional documents?", -1))
const _hoisted_19 = { class: "radio" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "yes",
  class: "mr-5"
}, "Yes", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "no" }, "No", -1))
const _hoisted_22 = {
  key: 0,
  class: "form-item"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "What are the functional document you have currently", -1))
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-73a2f312></option><option value=\"I have the UI/UX designs and I can share them\" data-v-73a2f312> I have the UI/UX designs and I can share them </option><option value=\"I have the wireframes, the designs are in process\" data-v-73a2f312> I have the wireframes, the designs are in process </option><option value=\"I have the wireframes, I want your team to help with the designs\" data-v-73a2f312> I have the wireframes, I want your team to help with the designs </option><option value=\"I just have a write-up ready and will be needing further\n              discussion\" data-v-73a2f312> I just have a write-up ready and will be needing further discussion </option><option value=\"Others\" data-v-73a2f312>Others</option>", 6)
const _hoisted_30 = [
  _hoisted_24
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "form-text" }, "Contact information", -1))
const _hoisted_32 = { class: "form-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fullname" }, "Full Name", -1))
const _hoisted_34 = { class: "form-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_36 = { class: "form-item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Country", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select your Country", -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "form-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone Number", -1))
const _hoisted_42 = { class: "form-item" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "companyName" }, "Company Name", -1))
const _hoisted_44 = { class: "form-item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Project Description", -1))
const _hoisted_46 = { class: "form-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "remark" }, "Any other remark? (optional)", -1))
const _hoisted_48 = { class: "form-item" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "aboutUs" }, "We're curious, how did you hear about us? (optional)", -1))
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-73a2f312>Tell us, how you heard about us</option><option value=\"LinkedIn\" data-v-73a2f312>LinkedIn</option><option value=\"A Friend\" data-v-73a2f312>Recommended by a friend</option><option value=\"Search Engine\" data-v-73a2f312>Search Engine(Google, Yahoo, etc)</option><option value=\"Social Media\" data-v-73a2f312>Social Media</option><option value=\"Blog or publication\" data-v-73a2f312>Blog or publication</option><option value=\"other\" data-v-73a2f312>Other</option>", 7)
const _hoisted_57 = [
  _hoisted_50
]
const _hoisted_58 = {
  class: "mt-3",
  type: "submit"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { key: 1 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "work-form",
        onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.work_with_us()), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "mr-2",
              id: "New",
              type: "radio",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.work.isNewProject) = $event)),
              value: true,
              name: "Project"
            }, null, 512), [
              [_vModelRadio, _ctx.work.isNewProject]
            ]),
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              class: "mr-2",
              id: "Existing",
              type: "radio",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.work.isNewProject) = $event)),
              value: false,
              name: "Project"
            }, null, 512), [
              [_vModelRadio, _ctx.work.isNewProject]
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "mr-2",
                value: "Posa SAAS Platform",
                name: "Posa SAAS Platform",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.work.services) = $event)),
                id: "4"
              }, null, 512), [
                [_vModelCheckbox, _ctx.work.services]
              ]),
              _hoisted_11
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "mr-2",
                value: "Sales Recording System",
                name: "Sales Recording System",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.work.services) = $event)),
                id: "5"
              }, null, 512), [
                [_vModelCheckbox, _ctx.work.services]
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "mr-2",
                name: "Inventory Management",
                value: "Inventory Management",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.work.services) = $event)),
                id: "6"
              }, null, 512), [
                [_vModelCheckbox, _ctx.work.services]
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "mr-2",
                name: "Online Store Setup",
                value: "Online Store Setup",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.work.services) = $event)),
                id: "7"
              }, null, 512), [
                [_vModelCheckbox, _ctx.work.services]
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "mr-2",
                name: "Fraud Prevention System",
                value: "Fraud Prevention System",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.work.services) = $event)),
                id: "8"
              }, null, 512), [
                [_vModelCheckbox, _ctx.work.services]
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "mr-2",
                name: "Other",
                value: "Other",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.work.services) = $event)),
                id: "9"
              }, null, 512), [
                [_vModelCheckbox, _ctx.work.services]
              ]),
              _hoisted_16
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.services.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                key: error.$uid,
                class: "error"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              class: "mr-2",
              id: "yes",
              type: "radio",
              name: "Yes",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.work.haveFunctionalDocument) = $event)),
              value: true,
              checked: ""
            }, null, 512), [
              [_vModelRadio, _ctx.work.haveFunctionalDocument]
            ]),
            _hoisted_20,
            _withDirectives(_createElementVNode("input", {
              class: "mr-2 ml-5",
              id: "no",
              type: "radio",
              value: false,
              name: "Yes",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.work.haveFunctionalDocument) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.work.haveFunctionalDocument]
            ]),
            _hoisted_21
          ])
        ]),
        (_ctx.work.haveFunctionalDocument)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("select", {
                name: "",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.work.currentFunctionalDocument) = $event)),
                id: "current"
              }, _hoisted_30, 512), [
                [_vModelSelect, _ctx.work.currentFunctionalDocument]
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.work.fullName) = $event)),
            placeholder: "Enter Full Name",
            id: "fullname"
          }, null, 512), [
            [_vModelText, _ctx.work.fullName]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.fullName.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.work.email) = $event)),
            placeholder: "Enter email",
            id: "email"
          }, null, 512), [
            [_vModelText, _ctx.work.email]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _withDirectives(_createElementVNode("select", {
            name: "",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.work.country) = $event)),
            id: "country"
          }, [
            _hoisted_38,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: country
              }, _toDisplayString(country), 9, _hoisted_39))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.work.country]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.country.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.work.phone) = $event)),
            placeholder: "Enter Phone Number",
            id: "phone"
          }, null, 512), [
            [_vModelText, _ctx.work.phone]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phone.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.work.companyName) = $event)),
            placeholder: "Enter your Company name",
            id: "companyName"
          }, null, 512), [
            [_vModelText, _ctx.work.companyName]
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _withDirectives(_createElementVNode("textarea", {
            name: "message",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.work.projectDescription) = $event)),
            id: "message",
            placeholder: "Enter your message"
          }, null, 512), [
            [_vModelText, _ctx.work.projectDescription]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.projectDescription.$errors, (error) => {
            return (_openBlock(), _createElementBlock("span", {
              key: error.$uid,
              class: "error"
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _withDirectives(_createElementVNode("textarea", {
            name: "message",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.work.remark) = $event)),
            id: "remark",
            placeholder: "Enter your message"
          }, null, 512), [
            [_vModelText, _ctx.work.remark]
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _withDirectives(_createElementVNode("select", {
            name: "",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.work.aboutUs) = $event)),
            id: "aboutUS"
          }, _hoisted_57, 512), [
            [_vModelSelect, _ctx.work.aboutUs]
          ])
        ]),
        _createElementVNode("button", _hoisted_58, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_59, _hoisted_61))
            : (_openBlock(), _createElementBlock("span", _hoisted_62, "Submit Request"))
        ])
      ], 32)
    ]),
    _hoisted_63,
    _createVNode(_component_Footer)
  ]))
}